import { render } from "./teaTrainTask.vue?vue&type=template&id=45f9d764&scoped=true"
import script from "./teaTrainTask.vue?vue&type=script&lang=js"
export * from "./teaTrainTask.vue?vue&type=script&lang=js"

import "./teaTrainTask.vue?vue&type=style&index=0&id=45f9d764&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9d764"]])

export default __exports__